<i18n lang="yaml" src="@/locales/common.yaml"></i18n>

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-select
          :items="dateRanges"
          :label="$t('labels.date_range')"
          v-model="selectedRangeName"
          item-value="name"
          item-title="nameLocal"
        >
          <template #item="{ props, item }">
            <v-list-item v-bind="props">
              <v-list-item-subtitle>
                <DateRangeText
                  :start="item.start"
                  :end="item.end"
                  class="float-right"
                ></DateRangeText>
                <div
                  class="d-flex"
                  :class="{
                    'justify-content-between': item.desc,
                    'justify-content-end': !item.desc,
                  }"
                >
                  <span v-if="item.desc" class="text-body-small">
                    {{ $t(item.desc) }}
                  </span>
                  <span>{{
                    item.start
                      ? `${formatDate(item.start)} - ${formatDate(item.end)}`
                      : ""
                  }}</span>
                </div>
              </v-list-item-subtitle>
            </v-list-item>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-row v-if="dateRange.custom">
      <!-- start date selector -->
      <v-col cols="12" :sm="6">
        <DatePicker
          v-model="start"
          :label="$t('title_fields.start_date')"
          :max-date="endRaw"
          validate-pair
          @validity-updated="handleValidityUpdated"
        >
        </DatePicker>
      </v-col>
      <!-- end date selector -->
      <v-col cols="12" :sm="6">
        <DatePicker v-model="end" :label="$t('title_fields.end_date')">
        </DatePicker>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { ymDateParse, smartDateParse } from "@/libs/dates";
import DateRangeText from "@/components/util/DateRangeText";
import DatePicker from "@/components/DatePicker.vue";

export default {
  name: "DateRangeSelector",
  components: { DateRangeText, DatePicker },
  data() {
    return {
      menuStart: false,
      menuEnd: false,
    };
  },
  emits: ["validityUpdated"],
  computed: {
    ...mapState({
      dateRangeName: "dateRangeName",
      startRaw: "dateRangeStart",
      endRaw: "dateRangeEnd",
    }),
    ...mapGetters({
      dateRange: "selectedDateRange",
      dateRangesRaw: "dateRanges",
    }),
    dateRanges() {
      return this.dateRangesRaw.map((item, index) => {
        return { ...item, nameLocal: this.$i18n.t(item.name), index: index };
      });
    },
    selectedRangeName: {
      get() {
        return this.dateRangeName;
      },
      set(value) {
        this.setDateRangeName(value);
      },
    },
    start: {
      get() {
        return {
          month: this.startRaw.getMonth(),
          year: this.startRaw.getFullYear(),
        };
      },
      set(value) {
        if (value && typeof value === "object" && "month" in value) {
          const day = value.day || 1;
          this.setDateRangeStart(new Date(value.year, value.month, day));
        } else if (typeof value === "string") {
          let date = ymDateParse(value);
          this.setDateRangeStart(date);
        } else {
          this.setDateRangeStart(value);
        }
      },
    },
    end: {
      get() {
        return {
          month: this.endRaw.getMonth(),
          year: this.endRaw.getFullYear(),
        };
      },
      set(value) {
        if ("month" in value) {
          this.setDateRangeEnd(new Date(value.year, value.month));
        } else {
          this.setDateRangeEnd(value);
        }
      },
    },
  },
  methods: {
    ...mapActions({
      setDateRangeName: "changeDateRangeObject",
      setDateRangeStart: "changeDateRangeStart",
      setDateRangeEnd: "changeDateRangeEnd",
    }),
    formatDate(dateString) {
      if (dateString) {
        const date = new smartDateParse(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        return `${year}-${month}`;
      } else {
        return this.$t("today");
      }
    },
    handleValidityUpdated(value) {
      this.$emit("validityUpdated", value);
    },
  },
};
</script>

<style scoped>
.justify-content-between {
  justify-content: space-between;
}
.justify-content-end {
  justify-content: flex-end;
}
</style>
